document.addEventListener('click', function (event) {
  const button = event.target.closest('.video-sound-toggle');
  if (!button) return;

  const wrapper = button.closest('.media-wrapper');
  const video = wrapper.querySelector('video');
  if (!video) return;

  // If this video is currently muted, unmute it and mute all others
  if (video.muted) {
    // Mute all other videos
    document.querySelectorAll('.media-wrapper video').forEach(v => {
        v.muted = true;
    });

    // Remove active state from all buttons
    document.querySelectorAll('.video-sound-toggle').forEach(btn => {
        btn.classList.remove('is-unmuted');
    });

    // Unmute current video
    video.muted = false;
    button.classList.add('is-unmuted');

  } else {
    // If already unmuted, mute it
    video.muted = true;
    button.classList.remove('is-unmuted');
  }
});
